import React from 'react';
import AutoFields from 'uniforms-antd/AutoFields';
import Icon from 'antd/lib/icon';
import Button from 'antd/lib/button';

import AutoForm from './uniforms/AutoForm';
import AutoField from './uniforms/AutoField';
import { withSurvey, SurveyManager } from './uniforms/uniforms-survey';

const ST_body = {
    margin: 10
};

const SurveyAction = props => (
    <Button style={ST_body} disabled={props.disabled} htmlType="button" onClick={props.action} size="large" type="primary">
        <Icon type={props.icon} style={{fontSize: 26, padding: 5}} />
        <br/>
        {props.text}
    </Button>
);

const SurveyForm = withSurvey(props => (
    <AutoForm
        // FIXME: Theres a weird behaviour with validation order when
        //        pressing "Prev"... To investigate later.
        key={props.page}
        model={props.model}
        onChangeModel={props.onChange}
        onSubmit={props.onSubmit}
        ref={props.onForm}
        schema={props.schema}
        showInlineError
    >
        <AutoFields autoField={AutoField} fields={props.fields} />
        <div>
                {!(!props.page && !!props.pages)   && (<SurveyAction action={props.onPrev}   disabled={!props.page && !!props.pages}    icon="left-circle-o"  text="Prev"   left />)}
                {!(props.page !== props.pages - 1) && (<SurveyAction action={props.onNext}   disabled={props.page !== props.pages - 1}  icon="check-circle-o" text="Submit" right />)}
                {!(props.page === props.pages - 1) && (<SurveyAction action={props.onNext}   disabled={props.page === props.pages - 1}  icon="right-circle-o" text="Next"   right />)}
        </div>
        <pre>Page: {props.page + 1} / {props.pages}</pre>
    </AutoForm>
));
// {(!props.page && !!props.pages)    && (<SurveyAction action={props.onCancel} disabled={!(!props.page && !!props.pages)} icon="close-circle-o" text="Cancel" left />)}

// This prevents rendering not finished schemas.
const safeSurveyManager = options => {
    const fields = options.fields.filter(field => field.name).reduce((fields, {name, ...field}) => Object.assign(fields, {[name]: field}), {});
    const pages  = options.pages.map(page => ({...page, fields: page.fields.filter(name => fields[name])}));
    const survey = new SurveyManager({fields, pages});
    survey.__cached = JSON.stringify({fields, pages});
    return survey;
};


class RenderSurvey extends React.Component {
    constructor (props) {
        super(props);
        this.state = {survey: safeSurveyManager(this.props.survey)};
    }

    componentWillReceiveProps (props) {
        this.setState(() => ({survey: safeSurveyManager(props.survey)}));
    }

    // NOTE: It won't react on non-survey prop change.
    shouldComponentUpdate (props, state) {
        return (this.state.survey.__cached !== state.survey.__cached);
    }

    render () {
        return (
            <SurveyForm
                key={this.state.survey.__cached}
                onPage={this.props.onPage}
                onSubmit={this.props.onSubmit}
                onCancel={this.props.onCancel}
                survey={this.state.survey}
            />
        );
    }
}

export default RenderSurvey;



// WEBPACK FOOTER //
// ./src/components/UI/Survey.jsx